module.exports = __webpack_public_path__ + "1135b5aeb2e3a8b398f17b677749217f.svg";